import { Progress } from "antd";
import IconGift from "assets/icons/icon-gift.png";
import IconReward from "assets/icons/icon-reward.png";
import ArrowLevel from "assets/icons/level-arrow.png";
import { LIST_MY_VIP, listGameProvider } from "contants/list-vip";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useScrollTop } from "hooks/useScrollTop";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { selectUsername } from "store/auth";
import { selectDataVipMember } from "store/member";
import { getVipMember } from "store/member/member.thunk";
import { Container } from "styles/helper";

import StyledLoyaltyProgramPage from "./loyaltyProgram.style";

const LoyaltyProgramPage = () => {
  useScrollTop();

  const username = useAppSelector(selectUsername);
  const dispatch = useAppDispatch();
  const dataVipMember = useAppSelector(selectDataVipMember);

  const [percent, setPercent] = useState<number>();

  useEffect(() => {
    const percentVip = 100 / dataVipMember.total_level;
    const percentPerLevel = percentVip * dataVipMember.current_level;
    setPercent(percentPerLevel);
  }, [dataVipMember]);
  useEffect(() => {
    if (!username) return;

    dispatch(getVipMember({ username }));
  }, [username]);

  const listEntries = Object.entries(dataVipMember.rebate);

  return (
    <StyledLoyaltyProgramPage>
      <Helmet>
        <title>RRRBets | Loyalty Levels: More Points - More Winning </title>
      </Helmet>
      <Container>
        <div className="loyalty__level">
          <div className="loyalty__level-current">
            <div className="header">
              <div className="header-level">
                <span>Lv{dataVipMember.current_level}</span>
              </div>
              <div className="header-text">
                Current Level: <span>Vip</span>
                <span> {dataVipMember.current_level}</span>
              </div>
            </div>
            <div className="process">
              <div className="process-detail">
                {Array.from(Array(8)).map((_, index) => (
                  <div key={index} className="item">
                    <img src={ArrowLevel} alt="" />
                  </div>
                ))}
              </div>
              <div className="process-bar">
                <Progress percent={percent} />
              </div>
              <div className="process-detail --text">
                {LIST_MY_VIP.map((itemVip) => (
                  <span
                    key={itemVip.key}
                    className={
                      dataVipMember.current_level === itemVip.key
                        ? "--active"
                        : ""
                    }
                  >
                    {itemVip.level}
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div className="loyalty__level-news">
            <span>**</span> Continuously updated every 5 minutes
          </div>
          <div className="loyalty__level-conditions">
            Distance to next level:
            <span> Vip {dataVipMember.next_level.level}</span>
          </div>
          <div className="loyalty__level-deposit header-process">
            <div className="header">
              <span>
                Current turnover : ${dataVipMember.next_level.current_turnover}
              </span>
              <span>Target : ${dataVipMember.next_level.turnover}</span>
            </div>
            <div className="progress">
              <Progress
                percent={Number(dataVipMember.next_level?.turnover_percentage)}
              />
            </div>
          </div>
        </div>
        <div className="loyalty__benefits">
          <div className="loyalty__benefits-title">
            <span>VIP</span> Exclusive Benefits
          </div>
          <div className="loyalty__benefits-list">
            <div className="item">
              <img src={IconGift} alt="" />
              <span>+{dataVipMember.benefit.birthday_bonus}</span>
              <p>Birthday Bonus</p>
            </div>
            <div className="item">
              <img src={IconReward} alt="" />
              <span>+{dataVipMember.benefit.upgrade_reward}</span>
              <p>Update Reward</p>
            </div>
          </div>
        </div>
        <div className="loyalty__discount">
          <div className="loyalty__discount-title">
            <span>VIP</span> Discount
          </div>
          <div className="loyalty__discount-list">
            {listEntries.map((item) => (
              <div key={item[0]} className="item">
                <div className="percent">{item[1]}</div>
                <span>{listGameProvider?.[item[0]]}</span>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </StyledLoyaltyProgramPage>
  );
};

export default LoyaltyProgramPage;
